import styled from 'styled-components';

export const StyledDeleteModal = styled.div`
  padding: 24px 28px;
`;

export const StyledDeleteTitle = styled.h3`
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 20px;
`;
